/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSelectionCheckboxBlankCircle: {
  name: 'temp-selection-checkbox-blank-circle';
  data: string;
} = {
  name: 'temp-selection-checkbox-blank-circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
